// Content for the Médailles Animaux (animal licensing) hero. Interface values are illustrative.
export type Bi = { fr: string; en: string }

export const ANIMALS_IMAGES = {
  pets: 'https://cdn.magicpatterns.com/patterns/generated-images/832f391a-1eae-4998-82b9-917951cde962.jpg',
  milo: 'https://cdn.magicpatterns.com/patterns/generated-images/959ea251-4e11-460d-a096-8bb119f05470.jpg',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/8604a75f-fffa-41a4-b6a9-101ab8fd41cb.jpg',
}

export const animalsCopy = {
  eyebrow: { fr: 'Médailles et licences pour animaux ATNA', en: 'ATNA Pet Tags & Licences' },
  line1: { fr: 'Enregistrer, payer,', en: 'Register, pay,' },
  line2: { fr: 'rappeler, retrouver.', en: 'remind, reunite.' },
  line3: { fr: 'Une communauté', en: 'A safer' },
  line4: { fr: 'plus sécuritaire.', en: 'community.' },
  body: {
    fr: 'Offrez aux citoyens une façon simple et rapide d’enregistrer leur animal, de renouveler leur médaille et de mettre à jour leurs informations — en ligne, sur votre portail et votre application.',
    en: 'Give residents a simple, fast way to register their pet, renew their licence and update their information — online, on your portal and in your app.',
  },
  primary: { fr: 'Voir le module en action', en: 'See the module in action' },
  secondary: { fr: 'Parler à notre équipe', en: 'Talk to our team' },
  question: { fr: 'Je veux enregistrer mon chien. Que dois-je faire ?',en: 'I want to register my dog. What do I need to do?' },
  answer: {
    fr: 'Voici ce qu’il vous faut pour enregistrer votre chien à Brossard.',
    en: 'Here’s what you need to register your dog in Brossard.',
  },
}

export const atnaChecks: { key: 'identity' | 'rules' | 'payment' | 'medal'; label: Bi }[] = [
  { key: 'identity', label: { fr: 'Propriété et identité vérifiées', en: 'Property and identity verified' } },
  { key: 'rules', label: { fr: 'Règlements applicables', en: 'Applicable by-laws' } },
  { key: 'payment', label: { fr: 'Paiement en ligne', en: 'Online payment' } },
  { key: 'medal', label: { fr: 'Médaille au dossier', en: 'Tag on file' } },
]

export const petProfile = {
  title: { fr: 'Mon animal', en: 'My pet' },
  name: 'Milo',
  breed: { fr: 'Chien · golden retriever',en: 'Dog · Golden Retriever' },
  active: { fr: 'Active', en: 'Active' },
  rows: [
    { key: 'licence', label: { fr: 'Licence active', en: 'Active licence' }, value: null },
    { key: 'expiry', label: { fr: 'Échéance', en: 'Expiry' }, value: { fr: '31 mars 2027', en: 'March 31, 2027' } },
    { key: 'number', label: { fr: 'Numéro de licence', en: 'Licence number' }, value: { fr: 'CR-2026-4587', en: 'CR-2026-4587' } },
    { key: 'vaccine', label: { fr: 'Vaccination', en: 'Vaccination' }, value: { fr: 'À jour', en: 'Up to date' } },
    { key: 'contact', label: { fr: 'Coordonnées', en: 'Contact details' }, value: { fr: 'À jour', en: 'Up to date' } },
  ] as { key: 'licence' | 'expiry' | 'number' | 'vaccine' | 'contact'; label: Bi; value: Bi | null }[],
}

export const animalsBenefits: { key: 'compliance' | 'safety' | 'lost' | 'revenue'; title: Bi; body: Bi }[] = [
  { key: 'compliance', title: { fr: 'Conformité', en: 'Compliance' }, body: { fr: 'Registre à jour et renouvellements automatisés.', en: 'An up-to-date registry and automated renewals.' } },
  { key: 'safety', title: { fr: 'Sécurité publique', en: 'Public safety' }, body: { fr: 'Animaux identifiés, communautés plus sécuritaires.', en: 'Identified animals, safer communities.' } },
  { key: 'lost', title: { fr: 'Animaux perdus', en: 'Lost pets' }, body: { fr: 'Signalement géolocalisé et retour plus rapide à la maison.', en: 'Geolocated reporting and a faster return home.' } },
  { key: 'revenue', title: { fr: 'Revenus', en: 'Revenue' }, body: { fr: 'Plus d’inscriptions et de renouvellements.', en: 'More registrations and renewals.' } },
]
